

export function getHealthPlanName(props) {
    const { hasAAL, hasFirstCare, hasHealthPlanLogin, hpIdentity } = props;
   
    if (hasAAL) {
        return "BSWQA-DFW ConnectedCare";
    } else if (hasFirstCare) {
        return "FirstCare Health Plans";
    } else if (hpIdentity) {
        if (hpIdentity.memberUserClaims.businessLineNames.includes("PPO") || hpIdentity.memberUserClaims.businessLineNames.includes("EPO")) {
            return "Baylor Scott & White Insurance Company";
        }
        if (hpIdentity.memberUserClaims.productName === "HMO Large Group") {
            return "Baylor Scott & White Care Plan";
        }
        //HMO Small Group/HMO Individua and Family HMO/Default
        return "Baylor Scott & White Health Plan";
    } else if (hasHealthPlanLogin) {
        return "Baylor Scott & White Health Plan";
    } else {
        return "";
    }
}

export function getProfileName(props) {
    const { hasAAL, hasHealthPlanLogin, hasFirstCare, hasMyChart, isProxyUser, currentPharmacyUser, hasPharmacyLogin } = props;
    const hasHealthPlan = hasAAL || hasHealthPlanLogin || hasFirstCare;
    const isMyChartProxyUser = isProxyUser;
    const pharmacyUser = (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser;

    if (hasHealthPlan && (!hasMyChart && !isMyChartProxyUser) && !pharmacyUser) {
        return "My Profile";
    } else {
        return "Patient Profile";
    }
}
export function showWellnessLink(props) {
    const { bffDashboardData, currentUser } = props;
    let showWellnessLink = false;
    if (currentUser && currentUser.epi && bffDashboardData && bffDashboardData.data && bffDashboardData.data.dcjStatus && bffDashboardData.data.dcjStatus.wellnessDCJList && bffDashboardData.data.dcjStatus.wellnessDCJList.length) {
        const dcjList = bffDashboardData.data.dcjStatus.wellnessDCJList;
        for (let i = 0; i < dcjList.length; i++) {
            let dcjitem = dcjList[i];
            if (dcjitem && dcjitem.patient_id && dcjitem.patient_id === currentUser.epi) {
                showWellnessLink = true;
                break;
            }
        }
    }
    return showWellnessLink;

}
/**
* @param {string} name the name of the feature from the memberships object.
* @returns {boolean} true if the feature is authorized via memberships or the epic array
*/
export function hasMyChartAuthorizedEpicFeature(name,props,state) {
    const { membershipsAuthorizedFeatures } = state;//elements of the memberships object that begin with hasAuthorizedFeature
    const myChartAuthorizedEpicFeatures = JSON.parse(props.myChartAuthorizedEpicFeatures);//from the app.config
    const enabled = myChartAuthorizedEpicFeatures[name] && myChartAuthorizedEpicFeatures[name].enabled;
    if (!enabled) return false;
    const epicAuthorizedFeatures = getEpicAuthorizedFeatures(props);
    return membershipsAuthorizedFeatures[name] || epicAuthorizedFeatures[myChartAuthorizedEpicFeatures[name].epicName];
}


/**
 * @returns {object}the AuthorizedFeatures array as an object
 */
export function getEpicAuthorizedFeatures(props) {
    const { activeProfile } = props;
    const hasEpicPatientAuthorizedFeatures = activeProfile && activeProfile.patient && activeProfile.patient.AuthorizedFeatures;
    const epicAuthorizedFeatures = hasEpicPatientAuthorizedFeatures ? activeProfile.patient.AuthorizedFeatures.reduce((a, element) => {
        a[element] = true;
        return a;
    }, {}) : {};
    return epicAuthorizedFeatures;
}